// @flow
import React, {PureComponent} from "react";
import riderIconPath from '../../../Assets/commonImages/rider_marker.svg';
import {connect} from "react-redux";
import SVGMarker, {SVGAnchor} from "./SVGMarker";
import AppSelectors from "../../../Store/Ducks/App/selectors";
import Markers from "../../../Store/Views/markers";


type ConnectedProps = {
    riderLocationLat: number,
    riderLocationLng: number,
    riderLocationBearing?: number,
    showRiderMarker: boolean,
};

class RiderMarker extends PureComponent<ConnectedProps> {
    render() {
        return (<SVGMarker
            key={"RiderMarkerSVG"}
            iconPath={riderIconPath}
            visible={this.props.showRiderMarker}
            lat={this.props.riderLocationLat || 0}
            lng={this.props.riderLocationLng || 0}
            bearing={this.props.riderLocationBearing || 0}
            anchorPosition={SVGAnchor.MIDDLE_CENTER}
            useMotion={true}
        />);
    }

};

const mapStateToProps = (state, props) => {
    return {
        showRiderMarker: Markers.shouldShowRiderMarker(state),
        riderLocationLat: AppSelectors.getRiderLocationLat(state),
        riderLocationLng: AppSelectors.getRiderLocationLng(state),
        riderLocationBearing: AppSelectors.getRiderLocationBearing(state),
    };
};

export default connect(mapStateToProps)(RiderMarker);



// WEBPACK FOOTER //
// ./src/Components/Map/Markers/RiderMarker.js